import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectIsReadOnly } from 'store/Faraday/selectors';
import ManualCreationModal from 'Screens/Contextualization/ManageEditCreate/components/ManualCreationModal';
import { Wrapper, ButtonWrapper } from './styled';
import AddButton from 'shared/ui/AddButton';
import { selectAllowedByRole } from 'Hooks/usePermission/selector';
import { FEATURE_VULNS, PERMISSION_TYPES } from 'Hooks/usePermission/permissions';

const CreateActions = () => {
  const [showModalCreation, setShowModalCreation] = useState(false);
  const readOnly = useSelector(selectIsReadOnly);
  const allowedByRole = useSelector((state) => selectAllowedByRole(state, FEATURE_VULNS, PERMISSION_TYPES.CREATE));
  const canUpdate = !readOnly && allowedByRole;

  const handleShow = () => {
    if (canUpdate) setShowModalCreation(true);
  };

  const handleClose = () => setShowModalCreation(false);

  return (
    <Wrapper>
      <ButtonWrapper data-tour="Add Vulnerability in Asset">
        <AddButton onClick={ handleShow } disabled={ !canUpdate }>Add Vulnerability</AddButton>
      </ButtonWrapper>
      { showModalCreation && <ManualCreationModal handleClose={ handleClose } entity="vulnsAssets" /> }
    </Wrapper>
  );
};

export default CreateActions;
